import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, Card, CardHeader, CardContent, CardActions } from '@material-ui/core';
import { colors, Button, TextInput } from 'kangarootime-ui';
import { BarLoader } from 'react-spinners';
import Preview from './Preview';

const AttachmentUpload = ({
  isOpen,
  onClose,
  attachment,
  handleUpload,
  uploading,
  channelName,
  ...props
}) => {
  if (!attachment) {
    return null;
  }

  const [messageText, setMessageText] = useState('');

  const handleClose = event => {
    // don't dismiss dialog while uploading
    if (uploading) {
      return;
    }

    onClose(event);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      onEscapeKeyDown={handleClose}
      onBackdropClick={handleClose}
    >
      <Card style={{ width: 540 }}>
        <CardHeader
          style={{ backgroundColor: colors.brand_1, color: '#FFFFFF' }}
          subheaderTypographyProps={{ color: '#FFFFFF' }}
          title='Upload Attachment'
          subheader={`Share with ${channelName}`}
        />
        <BarLoader
          loading={uploading}
          height={8}
          heightUnit='px'
          width={100}
          widthUnit='%'
          color={colors.persianPink}
        />
        <CardContent>
          <TextInput
            label='Add a message about the attachment'
            value={messageText}
            onChange={event => setMessageText(event.target.value)}
          />
          <Preview attachment={attachment} />
        </CardContent>
        <CardActions style={{ justifyContent: 'flex-end' }}>
          <Button disabled={uploading} onClick={() => handleUpload(attachment, messageText)}>Upload</Button>
        </CardActions>
      </Card>
    </Dialog>
  );
};

AttachmentUpload.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  attachment: PropTypes.instanceOf(File),
  uploading: PropTypes.bool,
  handleUpload: PropTypes.func,
  channelName: PropTypes.string
};

export default AttachmentUpload;
